import { render, staticRenderFns } from "./Stroop.vue?vue&type=template&id=fcac3968&scoped=true"
import script from "./Stroop.vue?vue&type=script&lang=js"
export * from "./Stroop.vue?vue&type=script&lang=js"
import style0 from "./Stroop.vue?vue&type=style&index=0&id=fcac3968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac3968",
  null
  
)

export default component.exports